// extracted by mini-css-extract-plugin
export default {"modal":"modal","content":"ModalInfo_content__jFgSP","ant-modal-content":"ant-modal-content","antModalContent":"ant-modal-content"};